module.exports = __webpack_public_path__ + "static/dashboard_bg@2x-443bed5149e2b1b06576d46f244bcfa4.png";